import { useState } from 'react';
import Header from '@components/Header';
import LandscapeNotifier from '@components/LandscapeNotifier';

import './LabourForecast.scss';
import LabourForecastDashboard from './LabourForecastDashboard';
import { FilterProvider } from './contexts/FilterContext';
import LabourForecastJobRoles from './LabourForecastJobRoles';
import AllSkills from './AllSkills';

const LabourForecast: React.FC = () => {
const [view, setView] = useState<'dashboard' | 'jobRoles' | 'skills'>('dashboard');



  return (
    <FilterProvider>
      <LandscapeNotifier />
      <Header />
      <div className="labourForecast overflow-scroll" style={{backgroundColor:"#F2F7FB"}}>
          {view === 'dashboard' && (
            <LabourForecastDashboard onViewAllJobs={() => setView('jobRoles')} onViewAllSkills={() => setView('skills')} />
          )}
          {view === 'jobRoles' && (
          <LabourForecastJobRoles onBack={() => setView('dashboard')} />
          )}
          {view === 'skills' && (
          <AllSkills onBack={() => setView('dashboard')} />
          )}
    </div>
    </FilterProvider>
  );
};

export default LabourForecast;
